import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/router-devtools';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import type { TRPCOptionsProxy } from '@trpc/tanstack-react-query';
import type { QueryClient } from '@tanstack/react-query';
import { ToasterSimple } from '@/components/ui/toaster-simple';

// Router context type
import type { AppRouter } from '@envase/api/client';

export interface RouterAppContext {
  trpc: TRPCOptionsProxy<AppRouter>;
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterAppContext>()({
  component: () => (
    <>
      <Outlet />
      <ToasterSimple />
      <TanStackRouterDevtools />
      <ReactQueryDevtools initialIsOpen={false} />
    </>
  ),
});

